/**
 * GSAP Plugins Registration
 */
gsap.registerPlugin(ScrollTrigger);

const EclatApp = {
    /**
     * スロールアニメーションの設定
     */
    setupScrollAnimations(): void {
        ScrollTrigger.getAll().forEach(trigger => trigger.kill());

        const targetElements = gsap.utils.toArray<HTMLElement>('.framein');
        targetElements.forEach((framein) => {
            framein.classList.remove('in');
            ScrollTrigger.create({
                trigger: framein,
                start: "top bottom-=30%",
                toggleClass: "in",
                once: true,
            });
        });
    },

    /**
     * テキストの分割処理 (.text_split)
     */
    setupTextSplit(): void {
        const splitElements = document.querySelectorAll<HTMLElement>('.text_split');
        splitElements.forEach((el) => {
            const html = el.innerHTML;
            const parts = html.match(/(<[^>]*>|[^<])/g) || [];
            let count = 1;

            el.innerHTML = parts
                .map((part) => {
                    if (part.startsWith('<')) return part;
                    return `<span class="split${count++}">${part}</span>`;
                })
                .join('');
        });
    },

    init(): void {
        const DISPLAY_TIMEOUT = 0;
        const rootElement = document.getElementById('eclat_Refa_20260525');
        let isShown = false;

        if (rootElement) rootElement.style.opacity = '0';

        /**
         * アプリを表示し、アニメーションを開始する
         */
        const showApp = () => {
            if (isShown) return;
            isShown = true;
            rootElement?.classList.add('is-show');
            // .is-showが付与された後にScrollTriggerを有効化する
            this.setupScrollAnimations();
        };

        this.setupTextSplit();

        // 経過したら強制的に表示
        const timeoutId = setTimeout(showApp, DISPLAY_TIMEOUT);

        // 読み込みが完了したら表示
        window.addEventListener('load', () => {
            clearTimeout(timeoutId);
            showApp();
        });
    },
};

// script.jsが動的にロードされるため、DOMContentLoadedを待たずに直接initを呼び出す
EclatApp.init();